import { render, staticRenderFns } from "./TestimonialCarouselAdminPage.vue?vue&type=template&id=390bb888&"
import script from "./TestimonialCarouselAdminPage.vue?vue&type=script&lang=js&"
export * from "./TestimonialCarouselAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports